import React, { useEffect, useMemo, useState } from 'react';
import type { GoodsDetailTab } from '../../types/GoodsDetailTab';
import { GoodsInfoTab } from './components/GoodsInfoTab';
import { GoodsWebviewContent } from './components/GoodsWebviewContent';
import { useGoodsDetail } from '../../queries/useGoodsDetail';
import { type SharedValue, withTiming } from 'react-native-reanimated';
import { Flex, useScreenSize } from '@banhala/ui-kit';
import { ReviewTab } from './components/ReviewTab';
import { InquiryTab } from './components/InquiryTab';
import { SizeTab } from './components/SizeTab';

export const GoodsContent: React.FC<{
  tab: GoodsDetailTab;
  onChangeTab: (next: GoodsDetailTab) => void;
  tabScrollX: SharedValue<number>;
}> = props => {
  const { data: goodsDetail } = useGoodsDetail();
  const [page, setPage] = useState(0);
  const { height: screenHeight } = useScreenSize();

  const [height, setHeight] = useState(screenHeight);

  const tabList = useMemo<{ type: GoodsDetailTab; url: string }[]>(() => {
    if (!goodsDetail) return [{ type: 'INFORMATION', url: '' }];
    return [
      { type: 'INFORMATION', url: '' },
      ...goodsDetail.tabs.map(tab => ({ type: tab.tab_type, url: tab.url })),
    ];
  }, [goodsDetail]);

  useEffect(() => {
    if (!goodsDetail) return;
    const nextTabIndex = tabList.findIndex(
      tabItem => tabItem.type === props.tab,
    );
    if (page !== nextTabIndex) {
      setPage(nextTabIndex);
      props.tabScrollX.value = withTiming(nextTabIndex, { duration: 100 });
    }
  }, [props.tab, goodsDetail, page, tabList, props.tabScrollX]);

  console.log('height', height);
  return (
    <Flex>
      {tabList.map((tab, index) => {
        if (index !== page) return null;

        if (tab.type === 'INFORMATION') {
          return (
            <GoodsInfoTab
              key={tab.type}
              focused={page === index}
              onChangeTabHeight={setHeight}
            />
          );
        }

        if (tab.type === 'REVIEW') {
          return (
            <ReviewTab
              key={tab.type}
              url={tab.url}
              focused={page === index}
              onChangeTabHeight={setHeight}
            />
          );
        }

        if (tab.type === 'INQUIRY') {
          return (
            <InquiryTab
              key={tab.type}
              url={tab.url}
              focused={page === index}
              onChangeTabHeight={setHeight}
            />
          );
        }
        if (tab.type === 'SIZE') {
          return (
            <SizeTab
              key={tab.type}
              url={tab.url}
              focused={page === index}
              onChangeTabHeight={setHeight}
            />
          );
        }
        return (
          <GoodsWebviewContent
            key={tab.type}
            url={tab.url}
            focused={page === index}
            onChangeHeight={height => {
              setHeight(height);
            }}
          />
        );
      })}
    </Flex>
  );
};
